import { MATRIX_CHANNEL, getDesignHome, getPreFix, getPrePageFix } from ".";
import Img1 from "@/assets/images/func-img-1-1.png";
import Img2 from "@/assets/images/func-img-1-2.png";
import Img3 from "@/assets/images/func-img-1-3.png";

import funcImg1 from "@/assets/images/func-img-2-1.png";
import funcImg2 from "@/assets/images/func-img-2-2.png";
import funcImg3 from "@/assets/images/func-img-2-3.png";

import ImgM1 from "@/assets/images/m-func-img-1-1.png";
import ImgM2 from "@/assets/images/m-func-img-1-2.png";
import ImgM3 from "@/assets/images/m-func-img-1-3.png";

export const footerInfo = {
  copyright:
    ' 美图公司 版权所有 &nbsp;&nbsp;违法和不良信息举报电话：400-990-9696, 网络文化经营<br/><a target="_blank" href="https://public.static.meitudata.com/meitu/business-license/meituwang/Meitu-business-license--20221216.pdf">营业执照</a> &nbsp; <a target="_blank" href="https://public.static.meitudata.com/meitu/business-license/meituwang/ICP-EDI-2019-2024.pdf">经营许可证</a> &nbsp; <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302000186">闽公网安备 35020302000186号</a>, <a target="_blank" href="https://beian.miit.gov.cn">闽B2-20040192</a>, <a target="_blank" href="https://public.static.meitudata.com/meitu/business-license/meituwang/network-culture-2021-2024.pdf">闽网文(2021)3392-058号</a>, <a target="_blank" href="https://beian.cac.gov.cn/#/index">网信算备 350203814951001230023号</a><br/>厦门美图网科技有限公司 地址:厦门市同安区西柯镇美峰创谷美图大厦',
  cols: [
    {
      title: "模板",
      key: "moban",
      mtValue: "template", // 埋点上报的value字段
      list: [
        {
          title: "电商",
          url: `${getDesignHome()}/templates?sceneId=00218`,
        },
        {
          title: "社交媒体",
          url: `${getDesignHome()}/templates?sceneId=00105`,
        },
        {
          title: "微信营销",
          url: `${getDesignHome()}/templates?sceneId=00106`,
        },
        {
          title: "微信公众号",
          url: `${getDesignHome()}/templates?sceneId=00985`,
        },
        {
          title: "行政办公/教育",
          url: `${getDesignHome()}/templates?sceneId=00219`,
        },
        {
          title: "生活娱乐",
          url: `${getDesignHome()}/templates?sceneId=001457`,
        },
        {
          title: "PPT",
          url: `${getDesignHome()}/templates?fid=002130`,
        },
      ],
    },
    {
      title: "支持与服务",
      key: "service",
      mtValue: "service", // 埋点上报的value字段
      list: [
        {
          title: "关于我们",
          url: `https://www.meitu.com/`,
        },
        {
          title: "加入我们",
          url: `https://hr.meitu.com/social-recruitment/meitu/54137/#/`,
        },
        {
          title: "用户协议",
          url: `${getDesignHome()}/agreement`,
        },
        {
          title: "隐私政策",
          url: `${getDesignHome()}/legal-agreement`,
        },
        {
          title: "热门搜索",
          url: `https://www.designkit.cn/hot`,
        },
      ],
    },
    {
      title: "友情链接",
      key: "link",
      mtValue: "link", // 埋点上报的value字段
      list: [
        {
          title: "供稿中心",
          url: `https://${getPreFix()}mcp.meitu.com/materials#/Entrance?matrix_channel=${MATRIX_CHANNEL}`,
        },
        {
          title: "美图秀秀网页版",
          url: `${getDesignHome()}/editor/`,
        },
        {
          title: "美图抠图",
          url: `https://${getPrePageFix()}.designkit.cn/cutout/?matrix_channel=${MATRIX_CHANNEL}`,
        },
        {
          title: "Wink",
          url: `https://wink.meitu.com/?channel=xdesignweb_blogroll_7`,
        },
      ],
    },
  ],
};

export interface CardItem {
  title: string;
  desc: string;
  url: string;
  img: string;
  statBtnKey: string;
}

export const pptUrl = `https://${getPrePageFix()}.designkit.cn/ppt/edit?from=ppt_landingpage`;

export const cardList: CardItem[] = [
  {
    title: "输入主题生成",
    desc: "一句话输入你需要制作的PPT主题，AI智能生成包含文字和排版的完整PPT，任何主题都可完成。",
    url: `${pptUrl}&activeTab=0`,
    img: Img1.src,
    statBtnKey: "one_sentence",
  },
  {
    title: "粘贴文本生成",
    desc: "输入你已有的文本内容，不论是大纲、笔记、摘要或者草稿，AI帮你润色生成高质量PPT。",
    url: `${pptUrl}&activeTab=1`,
    img: Img2.src,
    statBtnKey: "paste_text",
  },
  {
    title: "导入文件生成",
    desc: "支持导入word、pdf、ppt、xmind、txt等多种文件格式，一键上传秒变全新PPT。",
    url: `${pptUrl}&activeTab=2`,
    img: Img3.src,
    statBtnKey: "import_file",
  },
];

export const mCardList: Omit<CardItem, "url">[] = [
  {
    title: "输入主题",
    desc: "输入你需要生成的PPT主题，就能获得包含文字和排版的PPT，任何主题都可以试试。",
    img: ImgM1.src,
    statBtnKey: "one_sentence",
  },
  {
    title: "粘贴文本",
    desc: "只需一句话，输入你想要的PPT主题，AI就能帮你生成包含文案和排版的高质量PPT。",
    img: ImgM2.src,
    statBtnKey: "paste_text",
  },
  {
    title: "导入文件",
    desc: "支持导入word、pdf、ppt、xmind、txt等多种文件格式，一键上传秒变全新PPT。",
    img: ImgM3.src,
    statBtnKey: "import_file",
  },
];

export const cardList2: CardItem[] = [
  {
    title: "AI生图",
    desc: "支持生成海量风格的高质量配图。",
    url: pptUrl,
    img: funcImg1.src,
    statBtnKey: "ai_image",
  },
  {
    title: "AI文本润色",
    desc: "支持文本重写、美化、扩写、缩写，并可选择文字风格。",
    url: pptUrl,
    img: funcImg2.src,
    statBtnKey: "ai_text",
  },
  {
    title: "智能设计",
    desc: "提供海量图标、贴纸、花字等行业正版素材，编辑美化随心创作。",
    url: pptUrl,
    img: funcImg3.src,
    statBtnKey: "smart_design",
  },
];

export const mCardList2: Omit<CardItem, "url">[] = [
  {
    title: "AI生图",
    desc: "支持生成各种风格的高质量图片",
    img: funcImg1.src,
    statBtnKey: "ai_image",
  },
  {
    title: "AI文字改写",
    desc: "重写、美化、扩写、缩写，并支持选择文字风格",
    img: funcImg2.src,
    statBtnKey: "ai_text",
  },
  {
    title: "智能设计",
    desc: "贴纸、花字、多种元素随心设计",
    img: funcImg3.src,
    statBtnKey: "smart_design",
  },
];
